<template>
  <ul class="result-list">
    <li v-for="(contact, index) in contacts" :key="index">
      <div class="result-item">
        <h2 class="header capitalize">
          <span v-if="contact.firstName"
            >{{ contact.firstName.toLowerCase() + " " }}</span
          >
          <span v-if="contact.lastName"
            >{{
              contact.lastName.toLowerCase()
            }}</span
          >
          <span v-if="contact.id.length < 20"
            >, {{ contact.id }}</span
          >
        </h2>
        <!-- TODO: is it a good idea to pick the first entry?  -->
        <contact-bio :contact="contact" :keywords="keywords || []"></contact-bio>
      </div>
    </li>
  </ul>
</template>

<script>
import ContactBio from "./ContactBio";
import { mapGetters } from "vuex";

export default {
  name: "SearchContactsResults",
  props: {
    contacts: Array,
    keywords: Array,
  },
  components: {
    "contact-bio": ContactBio,
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
    }),
  },
};
</script>

<style scoped lang="scss">
.result-list {
  width: 700px;
}
.result-item {
  border: 1px solid lightgray;
  border-radius: 5px;
  margin: 2em auto 0;
  text-align: left;
}
.result-item:first-child {
  margin-top: 1em;
}
.header {
  text-align: center;
  color: #fff;
  font-size: 1.2em;
  padding: 5px 0;
  background-color: #007bff;
}
.capitalize {
  text-transform: capitalize;
}
.result-item-link {
  display: block;
  text-align: right;
  font-size: 0.85em;
}

@media only screen and (max-width: 768px) {
  .result-list {
    width: 100%;
  }
}
</style>
